const Facebook = () => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <path
        d="M60.453 0H3.547A3.573 3.573 0 0 0 0 3.547v56.906A3.573 3.573 0 0 0 3.547 64h30.64V39.253h-8.32v-9.68h8.32v-7.12c0-8.266 5.04-12.773 12.453-12.773 2.48 0 4.96 0 7.44.373v8.614h-5.093c-4.027 0-4.8 1.92-4.8 4.72v6.16h9.6l-1.254 9.68h-8.346V64h16.266A3.574 3.574 0 0 0 64 60.453V3.547A3.574 3.574 0 0 0 60.453 0Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Facebook;
